import { useMutation } from '@gogame/query';

import { editFinancialResult } from 'scenes/FinancialResults/sources/financialResults';

import { update } from '../queryKeyFactory';

export const useEditFinancialResult = () => {
  const updateMutation = useMutation(update(), editFinancialResult, {
    successMessage: () => 'Financial Result Updated',
  });
  return [updateMutation.mutateAsync, updateMutation];
};
